import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { Theme } from '@nivo/core';
import { Card, Switch, Typography } from '@material-ui/core';
import style from './ProGraph.module.css';
import { GraphData } from '../..';
import useDarkMode from '../../useDarkMode';
import moment from 'moment';

type ProGraphProps = {
  data: GraphData[];
  fullCareer: boolean;
  onFullCareerChange: (fullCareer: boolean) => void;
};

const lightTheme: Theme = {
  textColor: '#333',
  axis: { ticks: { text: { fill: '#333' } }, legend: { text: { fill: '#333' } } },
  grid: { line: { stroke: '#ddd' } },
};

const darkTheme: Theme = {
  textColor: '#eee',
  axis: { ticks: { text: { fill: '#eee' } }, legend: { text: { fill: '#eee' } } },
  grid: { line: { stroke: '#444' } },
  tooltip: { container: { background: '#333', color: '#eee' } },
};

const ProGraph = ({ data, fullCareer, onFullCareerChange }: ProGraphProps) => {
  const dark = useDarkMode();
  const graph = data ? (
    <ResponsiveLine
      data={data}
      theme={dark ? darkTheme : lightTheme}
      margin={{ top: 50, right: 60, bottom: 150, left: 60 }}
      curve="monotoneX"
      colors={{ scheme: 'nivo' }}
      lineWidth={2}
      enablePoints={false}
      enableGridX={false}
      enableGridY={false}
      xScale={{
        type: 'time',
        format: '%Y-%m-%d',
      }}
      xFormat="time:%Y-%m-%d"
      yScale={{
        type: 'linear',
        stacked: false,
        min: 'auto'
      }}
      axisBottom={{
        format: fullCareer ? '%b %Y' : '%b %d',
        legend: '',
        tickRotation: 54
      }}
      enablePointLabel={false}
      useMesh={true}
      tooltip={({ point }) => {
        return <div>{`${point.serieId} ${point.data.y} (${moment(point.data.x).format(fullCareer ? 'MMM YYYY' : 'MMM D')})`}</div>
      }}
      enableSlices={false}
      legends={[
        {
          anchor: 'bottom-left',
          direction: 'column',
          justify: false,
          translateX: 0,
          translateY: 140,
          itemsSpacing: 0,
          itemDirection: 'left-to-right',
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: 'circle',
          symbolBorderColor: 'rgba(0, 0, 0, .5)',
          effects: [
            {
              on: 'hover',
              style: {
                itemBackground: 'rgba(0, 0, 0, .03)',
                itemOpacity: 1
              }
            }
          ]
        }
      ]}
    />
  ) : '';
  return (
    <Card className={style.chart}>
      <div className={style.graph}>
        <div className={style.toggle}>
          <Typography variant="caption">1 an</Typography>
          <Switch
            checked={fullCareer}
            onChange={(_, checked) => onFullCareerChange(checked)}
            color="primary"
          />
          <Typography variant="caption">Carrière</Typography>
        </div>
        {graph}
      </div>
    </Card>
  );
}

export default ProGraph